import { AccessorioInfo } from './Accessorio';
import { DateTime } from 'luxon';

export class Biglietto {
    TicketID: number;
    TicketGUID: string;
    ParentID: number;
    Qta: number;
    Prezzo: number; // <-- PrezzoOnline?
    TipoPrezzo: number; // 1,2,3,4,5,6 per i feriali e 11,12,13 per i festivi // <-----------------------
    ScontoFisso: number;
    ScontoPerc: number;
    Servizio: number;
    PrezzoOnline: number;

    AliqIVA: number;
    RepartoRT: number;
    Sezionale: string;
    Mode: string; // stampa o acquista
    Immagine: string;
    Descrizione: string;
    Categoria: string;
    Descrizione2: string;
    Gruppo: string;
    MetodoPag: string; // cash o pos
    Tipo: string; // Intero, Ridotto, Feriale, Festivo
    DataBiglietto: DateTime;
    DataCreazione: DateTime;
    DataConvalida: DateTime;
    OraBiglietto: string;
    Evento: string;
    Code: string; // barcode o qrcode
    Convalidato: boolean;
    PosizioneLogo: number;
    VoucherNum: number;
    ListaConvalide: string[];
    NumBigliettiScalati: number;
    Ad: string;
    //    Variante: string;
    //    Accessori: Accessorio[]; // lista di accessori con relativa Qta e prezzo
    AccessoriInfo: AccessorioInfo[];
    GiftCard: boolean;
    TotaleAccessori: number;
    Corso: string;
    // PrenotaEntroLe: string;
    // SpostaEntroLe: string;

    Braccialetto: string;
    FriendName: string;
    FriendEmail: string;

    AbbNumIngressi: number;
    AbbNominativi: string;
    AbbGiorni: number;
    AbbMesi: number;
    AbbDataInizio: DateTime;
    AbbDataFine: DateTime;
    AbbCodice: string;

    CliNome: string;
    CliCognome: string;
    CliIndirizzo: string;
    CliCap: string;
    CliCitta: string;
    CliProv: string;
    CliNaz: string;
    CliRagSoc: string;
    CliPIVA: string;
    CliCodFisc: string;
    CliTelefono: string;
    CliEmail: string;
    CliGender: string;
    CliBornDate: DateTime;

    IsFestivo: boolean;

    Separa: boolean;
    PrezzoScontato: number;
    PrezzoListino: number;
    QtaMin: number;
    SogliaSconto: number;

    RichiedeReg: boolean;
    ConsentePreventivo: boolean; // <-----------------------
    ConsenteOverbooking: boolean; // <-----------------------
    Prenotabile: boolean; // <-----------------------

    IncludeOmbrellone: boolean;

    CampiObbCli: string;
    CampiFacCli: string;
    CampiObbPartec: string;
    CampiFacPartec: string;

    Hotel: Hotel;
    Partecipanti: Partecipante[];
    T1: string; // Presi dai campi custom T1...T4 dell'utente registrato
    T2: string;
    T3: string;
    T4: string;

    // Campi calcolati
    Disp: number;
    NascondiRegalaVoucher: boolean;
    NascondiVoucherSeparati: boolean;
    AggiungiRichiediFattura: boolean;
    AggiungiNote: boolean;
    AbbCodiciCompat: string;
    NascondiDisp: boolean;

    Coupon: string;
    Discount: number;
    Extra: number;
    TotalePagato: number;

    LabelQtaIt: string;
    LabelQtaEn: string;
    LabelQtaDe: string;
    LabelOpzioniIt: string;
    LabelOpzioniEn: string;
    LabelOpzioniDe: string;

    Note: string;

    // campi ausiliari

    prenotaEntroLe: string;
    spostaEntroLe: string;
    
    LabelServizio: string;
    LabelPartecipante: string;
    LabelPartecipanti: string;
    LabelGratis: string;

    constructor() {
        this.TicketID = 0;
        this.TicketGUID = '';
        this.ParentID = 0;
        this.Qta = 0;
        this.Prezzo = 0;
        this.ScontoFisso = 0;
        this.ScontoPerc = 0;
        this.Servizio = 0;
        this.TipoPrezzo = 0;

        this.AliqIVA = 0;
        this.RepartoRT = 0;
        this.Sezionale = '';
        this.Mode = ''; // stampa o acquista
        this.Immagine = '';
        this.Descrizione = ''; // in lingua
        this.Categoria = ''; // in italiano
        this.Descrizione2 = ''; // in lingua
        this.Gruppo = '';
        this.MetodoPag = ''; // cash o pos
        this.Tipo = '';
        this.DataBiglietto = null;
        this.DataCreazione = null;
        this.DataConvalida = null;
        this.OraBiglietto = '';
        this.Evento = '';
        this.Code = ''; // barcode o qrcode
        this.PosizioneLogo = 0;
        this.VoucherNum = 0;
        this.Convalidato = false;
        this.ListaConvalide = [];

        this.NumBigliettiScalati = 0;
        this.Ad = '';
        this.AccessoriInfo = [];
        this.GiftCard = false;
        this.TotaleAccessori = 0;
        this.Braccialetto = '';
        this.FriendName = '';
        this.FriendEmail = '';

        this.AbbNumIngressi = 0;
        this.AbbNominativi = '';
        this.AbbGiorni = 0;
        this.AbbMesi = 0;
        this.AbbDataInizio = null;
        this.AbbDataFine = null;
        this.AbbCodice = '';

        this.CliNome = '';
        this.CliCognome = '';
        this.CliIndirizzo = '';
        this.CliCap = '';
        this.CliCitta = '';
        this.CliProv = '';
        this.CliNaz = '';
        this.CliRagSoc = '';
        this.CliPIVA = '';
        this.CliCodFisc = '';
        this.CliTelefono = '';
        this.CliEmail = '';

        this.QtaMin = 0;
        this.SogliaSconto = 0;

        // Campi ausiliari

        this.prenotaEntroLe = '';
        this.spostaEntroLe = '';

        this.IsFestivo = false;
        this.Separa = false;
        this.PrezzoScontato = 0;
        this.PrezzoListino = 0;
        this.Disp = 0;

        this.RichiedeReg = false;
        this.ConsentePreventivo = false;
        this.ConsenteOverbooking = false;
        this.Prenotabile = false;
        this.IncludeOmbrellone = false;

        this.CampiObbCli = '';
        this.CampiFacCli = '';
        this.CampiObbPartec = '';
        this.CampiFacPartec = '';

        this.Hotel = null;
        this.Partecipanti = [];
        this.T1 = this.T2 = this.T3 = this.T4 = '';

        this.NascondiRegalaVoucher = false;
        this.NascondiVoucherSeparati = false;
        this.AbbCodiciCompat = '';
        this.NascondiDisp = false;

        this.Coupon = '';
        this.Discount = 0;
        this.Extra = 0;
        this.TotalePagato = 0;


        this.LabelQtaIt = '';
        this.LabelQtaEn = '';
        this.LabelQtaDe = '';
        this.LabelOpzioniIt = '';
        this.LabelOpzioniEn = '';
        this.LabelOpzioniDe = '';

        this.Note = '';

        this.LabelServizio = '';
        this.LabelPartecipante = '';
        this.LabelPartecipanti = '';
        this.LabelGratis = '';

        // TicketGUID = ticket.TicketGUID
        //ParentID = ticketInfo.TicketID
    }
}
export class BigliettoReq {
    Anno: number;
    Token: string;
    TicketID: number;
    ParentID: number;
    Qry: string;
}
export class BigliettoResp {
    Error: string;
    Ticket: Biglietto;
}
export class CaricaBigliettoReq {
    Token: string;
    jsonBiglietto: string;
}

export class Partecipante {
    name: string;
    surname: string;
    legalCode: string;
    bornDate: DateTime | null;
    gender: string;
    province: string;
    city: string;
    mobile: string;
    email: string;
    accessoriInfo: AccessorioInfo[];
    hcp: string;

    constructor(accInfo: AccessorioInfo[]) {
        this.name = '';
        this.surname = '';
        this.legalCode = '';
        this.bornDate = null;
        this.gender = '';
        this.province = '';
        this.city = '';
        this.mobile = '';
        this.email = '';
        this.hcp = '';
        //let clonedAccInfo = [];
        //accInfo.forEach(val => clonedAccInfo.push(Object.assign({}, val)));
        //this.accessoriInfo = clonedAccInfo ? clonedAccInfo : [];

        this.accessoriInfo = [];
        accInfo.forEach(val => {
            this.accessoriInfo.push(Object.assign({}, val));
        });
    }
}

export class Hotel {
    repositoryId: number;
    title: string;
    descr: string;
    image: string;
    disp1: number;
    disp2: number;
    disp3: number;
    disp4: number;
    disp5: number;
    disp6: number;
    price1: number;
    price2: number;
    price3: number;
    price4: number;
    price5: number;
    price6: number;
    qty1: number;
    qty2: number;
    qty3: number;
    qty4: number;
    qty5: number;
    qty6: number;
    label1: string;
    label2: string;
    label3: string;
    label4: string;
    label5: string;
    label6: string;
    person1: number;
    person2: number;
    person3: number;
    person4: number;
    person5: number;
    person6: number;

    constructor() {
        this.repositoryId = 0;
        this.title = '';
        this.descr = '';
        this.image = '';
        this.disp1 = 0;
        this.disp2 = 0;
        this.disp3 = 0;
        this.disp4 = 0;
        this.disp5 = 0;
        this.disp6 = 0;
        this.price1 = 0;
        this.price2 = 0;
        this.price3 = 0;
        this.price4 = 0;
        this.price5 = 0;
        this.price6 = 0;
        this.qty1 = 0;
        this.qty2 = 0;
        this.qty3 = 0;
        this.qty4 = 0;
        this.qty5 = 0;
        this.qty6 = 0;
        this.label1 = '';
        this.label2 = '';
        this.label3 = '';
        this.label4 = '';
        this.label5 = '';
        this.label6 = '';
        this.person1 = 1;
        this.person2 = 2;
        this.person3 = 3;
        this.person4 = 4;
        this.person5 = 5;
        this.person6 = 6;
    }
}

export class CheckHotelReq {
    store: string;
    hotelId: number;  // di hotel info
    ticketId: number;
    evento: string;
    lang: string;

    constructor() {
        this.store = '';
        this.hotelId = 0;
        this.ticketId = 0;
        this.evento = '';
        this.lang = '';
    }
}

export class CheckHotelResp {
    error: string;
    hotel: Hotel;

    constructor() {
        this.error = '';
        this.hotel = null;
    }
}

export class CheckCouponReq {
    store: string;
    biglietti: Biglietto[];
    coupon: string;

    constructor() {
        this.store = '';
        this.biglietti = [];
        this.coupon = '';
    }
}

export class CheckCouponResp {
    error: string;
    discount: number;

    constructor() {
        this.error = '';
        this.discount = 0;
    }
}

export class MyRes
{
    id: number;
    price: number;
    disp: number;
    qty: number;
    descr: string;

    public MyRes()
    {
        this.id = 0;
        this.price = 0;
        this.qty = 0;
        this.disp = 0;
        this.descr = '';
    }
}

export class CheckRisorseReq {
    store: string;
    ticketInfoId: number;  // di TicketInfo
    lang: string;

    constructor() {
        this.store = '';
        this.ticketInfoId = 0;
        this.lang = '';
    }
}

export class CheckRisorseResp {
    error: string;
    risorse: MyRes[];

    constructor() {
        this.error = '';
        this.risorse = null;
    }
}
